import React from 'react';
import { useDispatch } from 'react-redux';
import { bufferTime, delay, filter } from 'rxjs';

import { getEntityLeaderboardNotificationStream } from './entity-leaderboard-notifications';
import { EntityLeaderboardNotification } from '@neptune/shared/entity-leaderboard-domain';

type HookParams = {
  organizationId?: string;
  projectId?: string;
  entityTypes: string[];
  onNotify: (notifications: EntityLeaderboardNotification[]) => void;
};

export const useEntityLeaderboardChangedNotifications = ({
  organizationId,
  projectId,
  entityTypes,
  onNotify,
}: HookParams) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (organizationId != null && projectId != null) {
      const subscription = getEntityLeaderboardNotificationStream({
        organizationId,
        projectId,
        entityTypes,
      })
        .pipe(
          bufferTime(1200),
          filter((notifications) => notifications.length > 0),
          // we need to delay by a few seconds because of possible race condition between asking elastic search and reindexing
          delay(2000),
        )
        .subscribe(onNotify);

      return () => subscription.unsubscribe();
    }
  }, [dispatch, organizationId, projectId, entityTypes, onNotify]);
};
